export enum Roles {
    ROLE_APPLICATION_ADMIN = 'ROLE_APPLICATION_ADMIN',
    ROLE_ORGANISATION_ADMIN = 'ROLE_ORGANISATION_ADMIN',
    ROLE_MANAGE_TRAINING_PROVIDER = 'ROLE_MANAGE_TRAINING_PROVIDER',
    ROLE_USER = 'ROLE_USER',
}
